import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const FEAST_PACKAGES = [
  {
    id: 1,
    name: 'Authentic Palpali Bhoj',
    price: 'NPR 450 / guest',
    items: ['Palpali Chukauni', 'Batuk & Sel Roti', 'Mutton Curry / Local Chicken', 'Basmati Rice & Dal Fry', 'Pickle & Salad', 'Gulab Jamun / Jalebi'],
    tag: 'Palpali Specialty',
    emoji: '🍱'
  },
  {
    id: 2,
    name: 'Newari Samay Baji Feast',
    price: 'NPR 600 / guest',
    items: ['Samay Baji & Baji (Beaten Rice)', 'Choila (Spiced Meat)', 'Wo (Bara) & Kachila', 'Aalu Wala & Bhatmas', 'Bhaktapur Juju Dhau (Curd)', 'Traditional Beverages'],
    tag: 'Newari Tradition',
    emoji: '🍲'
  },
  {
    id: 3,
    name: 'Grand Royal Banquet Buffet',
    price: 'NPR 850 / guest',
    items: ['Paneer Butter Masala & Dal Makhani', 'Butter Chicken / Fish Fry', 'Veg Pulao & Naan Bread', 'Live Pasta & Chaat Counter', 'Ice Cream & Chocolate Fountain', 'Soft Drinks & Mocktails'],
    tag: 'Royal Banquet',
    emoji: '👑'
  }
];

const TENT_SETUPS = [
  {
    name: 'Royal Palpali Floral Mandap',
    desc: 'Lavish mandap decorated with fresh marigolds, red roses, gold velvet curtains, and traditional brass oil lamps.',
    price: 'NPR 45,000 / setup',
    emoji: '🌸'
  },
  {
    name: 'Yogikuti Grand Stage Backdrop',
    desc: 'Elevated stage setup with LED backdrop lighting, crystal chandeliers, royal thrones, and white floral arches.',
    price: 'NPR 60,000 / setup',
    emoji: '🎭'
  },
  {
    name: 'Fairy Light & Marquee Canopy',
    desc: 'Romantic outdoor marquee tent canopy with warm Edison bulbs and full flooring setup for evening receptions.',
    price: 'NPR 28,000 / setup',
    emoji: '✨'
  }
];

export default function CateringAbout() {
  const navigate = useNavigate();

  // Banquet Price Estimator State
  const [guestCount, setGuestCount] = useState(300);
  const [packageType, setPackageType] = useState(450);

  const estimatedTotal = guestCount * packageType;

  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        {/* Unified Hero Section */}
        <section className="hero-section">
          <div className="hero-content">
            <div style={{ marginBottom: '1.2rem' }}>
              <span className="badge" style={{ background: 'rgba(247, 208, 112, 0.25)', color: '#F7D070', border: '1px solid rgba(247, 208, 112, 0.4)' }}>
                ✦ SABITRI CATERING AND TENT HOUSE ✦
              </span>
            </div>

            <h1 className="hero-title">
              Authentic Nepalese Bhoj & Royal Banquet Catering
            </h1>

            <p className="hero-subtitle">
              Directed by <strong>Krishna Khanal</strong> (Contact: <strong>9867155395</strong>) & Partner <strong>Laxmikant Timilsina</strong> (Contact: <strong>9857074103</strong>). Corporate Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>.
            </p>

            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn btn-secondary" onClick={() => navigate('/catering/menu')}>
                Explore Food Menus →
              </button>
              <button className="btn btn-tertiary" onClick={() => navigate('/catering/booking')}>
                Book Catering for Event →
              </button>
            </div>
          </div>
        </section>

        {/* Stat Box Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1.5rem',
          marginBottom: '4rem'
        }}>
          <div className="stat-box">
            <div className="stat-number">500+</div>
            <div className="stat-label">Bhoj & Banquets Served</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">100%</div>
            <div className="stat-label">Hygienic 5-Star Cooking</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">Palpali</div>
            <div className="stat-label">Authentic Recipe Tradition</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">Complete</div>
            <div className="stat-label">Tent & Mandap Setup</div>
          </div>
        </div>

        {/* Feast Packages Showcase */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">Signature Feast Packages</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            Prepared by master culinary chefs under direct supervision of Krishna Khanal.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {FEAST_PACKAGES.map((f) => (
            <div key={f.id} className="card pillar-card" style={{ minHeight: '360px', textAlign: 'left' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                  <span style={{ fontSize: '2.5rem' }}>{f.emoji}</span>
                  <span className="badge-light">{f.tag}</span>
                </div>
                <h3 style={{ fontSize: '1.6rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.2rem', fontFamily: 'var(--serif)' }}>
                  {f.name}
                </h3>
                <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#8C6A23', marginBottom: '1rem' }}>
                  {f.price}
                </div>

                <ul style={{ listStyle: 'none', fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.8, marginBottom: '1.5rem' }}>
                  {f.items.map((item, idx) => (
                    <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <span style={{ color: '#9E1B32', fontWeight: 800 }}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <button className="btn btn-primary btn-sm btn-full" onClick={() => navigate('/catering/booking')}>
                  Book This Feast Package →
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Tent House & Mandap Decor Section */}
        <div style={{ marginBottom: '1rem' }}>
          <h2 className="section-title">Tent House & Mandap Decor</h2>
          <p style={{ textAlign: 'center', color: '#6E615E', marginBottom: '3rem' }}>
            Marquee tents, lighting, stage backdrops, and Palpali floral mandaps.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(310px, 1fr))',
          gap: '2rem',
          marginBottom: '4rem'
        }}>
          {TENT_SETUPS.map((t, idx) => (
            <div key={idx} className="card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: '2.5rem', marginBottom: '0.6rem' }}>{t.emoji}</div>
                <h3 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.3rem', fontFamily: 'var(--serif)' }}>
                  {t.name}
                </h3>
                <div style={{ fontSize: '0.9rem', fontWeight: 700, color: '#8C6A23', marginBottom: '0.8rem' }}>
                  💰 {t.price}
                </div>
                <p style={{ fontSize: '0.86rem', color: '#6E615E', lineHeight: 1.6 }}>
                  {t.desc}
                </p>
              </div>

              <div style={{ marginTop: '1.2rem' }}>
                <button className="btn btn-secondary btn-sm btn-full" onClick={() => navigate('/decor/quote')}>
                  Request Setup Quote →
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Interactive Banquet Price Estimator */}
        <div className="card" style={{
          background: 'linear-gradient(135deg, #1C1014 0%, #28171C 100%)',
          color: 'white',
          border: '1.5px solid #D4AF37',
          marginBottom: '4rem',
          textAlign: 'center'
        }}>
          <span className="badge" style={{ background: 'rgba(212, 175, 55, 0.25)', color: '#F7D070', marginBottom: '0.8rem' }}>
            📊 Interactive Catering Banquet Estimator
          </span>
          <h2 style={{ fontFamily: 'var(--serif)', fontSize: '2.2rem', fontWeight: 700, color: '#F7D070', margin: '0.4rem 0 1.5rem' }}>
            Estimate Your Wedding Feast Budget
          </h2>

          <div style={{ maxWidth: '600px', margin: '0 auto', textAlign: 'left' }}>
            <div style={{ marginBottom: '1.2rem' }}>
              <label style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.84rem', fontWeight: 700, display: 'block', marginBottom: '0.4rem' }}>
                Select Feast Menu Tier:
              </label>
              <select
                value={packageType}
                onChange={(e) => setPackageType(Number(e.target.value))}
                style={{ width: '100%', padding: '0.8rem', borderRadius: '12px', background: '#fff', color: '#1A1215', fontWeight: 700 }}
              >
                <option value={450}>Authentic Palpali Bhoj (NPR 450 / guest)</option>
                <option value={600}>Newari Samay Baji Feast (NPR 600 / guest)</option>
                <option value={850}>Grand Royal Banquet Buffet (NPR 850 / guest)</option>
              </select>
            </div>

            <div style={{ marginBottom: '1.8rem' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', color: 'white', fontSize: '0.86rem', fontWeight: 700, marginBottom: '0.4rem' }}>
                <span>Adjust Number of Guests:</span>
                <span style={{ color: '#F7D070' }}>{guestCount} Guests</span>
              </div>
              <input
                type="range"
                min="100"
                max="1200"
                step="50"
                value={guestCount}
                onChange={(e) => setGuestCount(Number(e.target.value))}
                style={{ width: '100%', accentColor: '#F7D070' }}
              />
            </div>

            <div style={{ background: '#0F090B', padding: '1.5rem', borderRadius: '20px', textAlign: 'center', border: '1.5px solid #D4AF37' }}>
              <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.7)', textTransform: 'uppercase' }}>Estimated Feast Total</div>
              <div style={{ fontSize: '2.8rem', fontWeight: 900, color: '#F7D070', margin: '0.2rem 0', fontFamily: 'var(--serif)' }}>
                NPR {estimatedTotal.toLocaleString()}
              </div>
              <button className="btn btn-secondary btn-full" style={{ marginTop: '0.8rem' }} onClick={() => navigate('/catering/booking')}>
                Book This Banquet Feast →
              </button>
            </div>
          </div>
        </div>

        {/* Directors & Corporate Office Card */}
        <div className="card" style={{ border: '1.5px solid #E8DFD1', background: '#fff' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'center' }}>
            <div>
              <span className="badge-light">🏢 Corporate Contact & Offices</span>
              <h3 style={{ fontSize: '1.7rem', fontWeight: 700, color: '#9E1B32', margin: '0.5rem 0', fontFamily: 'var(--serif)' }}>
                Sabitri Catering and Tent House
              </h3>
              <p style={{ fontSize: '0.88rem', color: '#6E615E', lineHeight: 1.65, marginBottom: '1rem' }}>
                Main Office: <strong>Yogikuti Chowk, Butwal-10, Lumbini, Nepal</strong>.<br />
                Partner Office: <strong>Tansen-09, Palpa, Nepal</strong>.
              </p>
              <div style={{ display: 'flex', gap: '0.8rem', flexWrap: 'wrap' }}>
                <a href="tel:9867155395" className="btn btn-primary btn-sm">
                  📞 Call Krishna: 9867155395
                </a>
                <a href="tel:9857074103" className="btn btn-secondary btn-sm">
                  📞 Call Laxmikant: 9857074103
                </a>
              </div>
            </div>

            <div style={{ background: '#FAF6ED', padding: '1.5rem', borderRadius: '16px', border: '1px solid #E8DFD1' }}>
              <h4 style={{ fontWeight: 800, color: '#1C1014', marginBottom: '0.5rem' }}>💻 Technical Support</h4>
              <p style={{ fontSize: '0.84rem', color: '#6E615E', lineHeight: 1.6, marginBottom: '0.8rem' }}>
                For web application or digital technical issues, contact system architect <strong>Prakash Sharma Timilsina</strong>.
              </p>
              <a href="https://pourkas.org" target="_blank" rel="noopener noreferrer" style={{ fontSize: '0.84rem', color: '#9E1B32', fontWeight: 800, textDecoration: 'underline' }}>
                Visit Digital Portfolio: pourkas.org →
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
